import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Vas from '../Vas';
import $ from 'jquery';
import '../css/Tariffing.css';
import { ExtendedButton,MessageBox, TariffingProductsToPoints, Checkbox } from 'component-lib';
import { Jump,CheckFields } from 'utils-lib';


var moment = require('moment');
moment().format();

class Tariffing  extends Component {

    //#region Komponente
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.me = this;
        this.state.TimeOut = '';

        this.ConfigDataProtection = Vas.Config.DataProtection;
        this.ConfigShowSSL = Vas.Config.SSL.ShowSSL;
        this.TariffProducts = [];
        Vas.clearLocalStorage(true);
        this.ButtonClicked = false;
    }

    componentDidMount(){
      let me = this;
      document.addEventListener("keydown", function(event) {
          if (me.TimeOut){
              window.clearTimeout(me.TimeOut);
          }
      });

      this.FontSizeClick();
      
    }

    Update(observer)
    {
      
        this.setState({},()=>{
        });
    }
    
    jumpTofirst(first,id){
      Jump.jump(1,id,null,null,first);
      
    }

    checkFields(){

      let filled = this.refs.Tariffing.checkFields();
      let result = true;

      if(document.getElementById('Price').value == ''){
        filled[0] = false;
      }

      if(this.ConfigDataProtection.Tariffing === true){
        result = CheckFields.CheckCheckBox([this.refs.AcceptPrivacy,this.refs.AcceptTariffTerms])[0] > 1 ? true : false;
      }    

      if(filled[0] === false || result === false){
        ReactDOM.render(<MessageBox 
          Message={Vas.Resources.Labels["NotAllFields"]} 
          Title={Vas.Resources.Titles["Note"]} 
          Click={()=>{
            this.jumpTofirst(filled[1],1); 
          }}
          />
            ,document.getElementById('messageContainer'));

        return false
      }else{
        return true
      }
  
    }

    Order(){//bestellen als Bestandskunde
        let filled = this.checkFields();
        if (filled === true){
            
          let tariff = this.refs.Tariffing.returnTariffProduct();
          localStorage.setItem("Tariff", JSON.stringify(tariff));
          Vas.GetView('Login',null,false);
            
        }  
    }

    Order2(){//bestellen als Neukunde

        let filled = this.checkFields();
        if (filled === true){
            
          let tariff = this.refs.Tariffing.returnTariffProduct();
          localStorage.setItem("Tariff", JSON.stringify(tariff));
                          
          Vas.GetView('OrderNewCustomer', null, false);
            
        }
    }
    
    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');

      //Schriftgröße bei Klick in 2er Schritten erhöhen

        if(schriftgröße != null){
              switch(schriftgröße){
                case "0":
                  $("#root").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                  $(".OfflineMenuItem, .LinkText").removeClass("Schriftgröße_22").addClass("Schriftgröße_23");
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".linkButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".footerMail").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                  $(".footer").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                  $(".tariffingform > table:nth-child(2) > tbody:nth-child(2) > tr:nth-child(1) > td:nth-child(1)").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".ConfirmationLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $("#HintContractStartText").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $("#HintContractStartText > div:nth-child(1)").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".SideNavOffline table td").removeClass("Schriftgröße_32").addClass("Schriftgröße_33");

                  $('#TariffProducts').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#TermsOfUsage').removeClass("Top_475").addClass("Top_523");

                break;
                case "1":
                  $("#root").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                  $(".OfflineMenuItem, .LinkText").removeClass("Schriftgröße_23").addClass("Schriftgröße_18");
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $(".linkButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $(".footerMail").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                  $(".footer").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                  $(".tariffingform > table:nth-child(2) > tbody:nth-child(2) > tr:nth-child(1) > td:nth-child(1)").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $(".ConfirmationLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $("#HintContractStartText").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $("#HintContractStartText > div:nth-child(1)").removeClass("Schriftgröße_17").addClass("Schriftgröße_12");
                  $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $(".SideNavOffline table td").removeClass("Schriftgröße_33").addClass("Schriftgröße_28");

                  $('#TariffProducts').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('#TermsOfUsage').removeClass("Top_523").addClass("Top_423");

                break;
                case "2":
                  $("#root").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".OfflineMenuItem, .LinkText").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $(".linkButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $(".footerMail").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".footer").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".tariffingform > table:nth-child(2) > tbody:nth-child(2) > tr:nth-child(1) > td:nth-child(1)").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $(".ConfirmationLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $("#HintContractStartText").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $("#HintContractStartText > div:nth-child(1)").removeClass("Schriftgröße_12").addClass("Schriftgröße_13");
                  $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $(".SideNavOffline table td").removeClass("Schriftgröße_28").addClass("Schriftgröße_29");

                  $('#TariffProducts').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                break;
                case "3":
                  $("#root").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".OfflineMenuItem, .LinkText").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $(".linkButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $(".footerMail").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".footer").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".tariffingform > table:nth-child(2) > tbody:nth-child(2) > tr:nth-child(1) > td:nth-child(1)").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $(".ConfirmationLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $("#HintContractStartText").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $("#HintContractStartText > div:nth-child(1)").removeClass("Schriftgröße_13").addClass("Schriftgröße_14");
                  $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $(".SideNavOffline table td").removeClass("Schriftgröße_29").addClass("Schriftgröße_30");

                  $('#TariffProducts').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                  $('#TermsOfUsage').removeClass("Top_423").addClass("Top_450");

                break;
                case "4":
                  $("#root").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".OfflineMenuItem, .LinkText").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".linkButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".footerMail").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".footer").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".tariffingform > table:nth-child(2) > tbody:nth-child(2) > tr:nth-child(1) > td:nth-child(1)").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".ConfirmationLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $("#HintContractStartText").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $("#HintContractStartText > div:nth-child(1)").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".SideNavOffline table td").removeClass("Schriftgröße_30").addClass("Schriftgröße_31");

                  $('#TariffProducts').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#TermsOfUsage').removeClass("Top_450").addClass("Top_475");

                break;
                case "5":
                  $("#root").removeClass("Schriftgröße_22").addClass("Schriftgröße_20");
                  $(".OfflineMenuItem, .LinkText").removeClass("Schriftgröße_21").addClass("Schriftgröße_22");
                  $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".linkButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".footerMail").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                  $(".footer").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                  $(".tariffingform > table:nth-child(2) > tbody:nth-child(2) > tr:nth-child(1) > td:nth-child(1)").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".ConfirmationLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $("#HintContractStartText").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $("#HintContractStartText > div:nth-child(1)").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".SideNavOffline table td").removeClass("Schriftgröße_31").addClass("Schriftgröße_32");

                  $('#TariffProducts').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#TermsOfUsage').removeClass("Top_475").addClass("Top_523");

                break;
              }
        }
    }

   handleChange(){
    if(localStorage.getItem("TariffProduct") != null)
    {
      if(document.getElementById("Motiv1").checked) {
        var motiv1 = JSON.parse(localStorage.getItem("Motiv1"));
        localStorage.setItem("TariffProduct", JSON.stringify(motiv1[0]));
      } else if(document.getElementById("Motiv2").checked) {
        var motiv2 = JSON.parse(localStorage.getItem("Motiv2"));
        localStorage.setItem("TariffProduct", JSON.stringify(motiv2[0]));
      } else if(document.getElementById("Motiv3").checked) {
        var motiv3 = JSON.parse(localStorage.getItem("Motiv3"));
        localStorage.setItem("TariffProduct", JSON.stringify(motiv3[0]));
      }
    }
   }

    render()
    {
      let ssl = <td></td>
      if(this.ConfigShowSSL === true){
        ssl = <td colSpan={2}>
        <img
          id={"SSLogo"}
          className={"SSLogo"}
          src={document.location.origin + "/images/le-logo-standard.png"}
          style={{display: 'none'}}
          alt={"SSLogo"} />
        </td>
      }

      let dataProtection = <tr></tr>;
      if(this.ConfigDataProtection.Tariffing === true){
        dataProtection =
        <tr>
          <td>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <table style={{width:"450px"}}>
                        <tbody>
                          <tr>
                            <td
                              colSpan={2}
                              valign="top" ><Checkbox
                                ref={"AcceptPrivacy"}
                                Id={"checkboxAcceptPrivacy"}
                                onClick={()=>{this.setState({ AcceptPrivacys:$("#acceptPrivacy").val() });}} /></td>
                            <td><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["AcceptPrivacy"]}*</div></td>
          
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>  
                  <tr>
                    <td colSpan={2}>
                      <ExtendedButton 
                        Usable={true} 
                        Text={Vas.Resources.Labels["ViewHere"]} 
                        OnClick={()=>{ window.open(Vas.ApplicationUrl+"/20_10_16_Hinweise_zur_Datenverarbeitung_und_zum_Datenschutz.pdf"); }} 
                        Id={"btoDataProtection"}
                        Width={170} />
                    </td>
                  </tr>  
                  <tr >
                    <td>
                      <table style={{width:"450px"}}>
                        <tbody>
                          <tr>
                            <td
                              colSpan={2}
                              valign="top" ><Checkbox
                                ref={"AcceptTariffTerms"}
                                Id={"checkboxAcceptTariffTerms"}
                                onClick={()=>{this.setState({ AcceptTariffTerms:$("#acceptTariffTerms").val() });}} /></td>
                            <td><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["AcceptTariffTerms"]}*</div></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <ExtendedButton 
                        Usable={true} 
                        Text={Vas.Resources.Labels["ViewHere"]} 
                        OnClick={()=>{ window.open(this.ConfigDataProtection.LinkTarifBestimmungen); }} 
                        Id={"btoTariffTerms"}
                        Width={170} />
                    </td>
                  </tr> 
                  <tr>
                    {ssl}
                  </tr>
                </tbody>
              </table>
          </td>
        </tr>
      }
        var motiv1Image = <input type={"radio"} id={"Motiv1"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-50px'}} onClick={() =>{this.handleChange();}} />;
        var motiv2Image = <input type={"radio"} id={"Motiv2"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-50px'}} onClick={() =>{this.handleChange();}} />;
        var motiv3Image = <input type={"radio"} id={"Motiv3"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-50px'}} onClick={() =>{this.handleChange();}} />;

        if(localStorage.getItem("SelectedMotiv") != null){
          if(localStorage.getItem("SelectedMotiv") == 1){
            motiv1Image = <input type={"radio"} id={"Motiv1"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-50px'}} checked={true} onClick={() =>{this.handleChange();}} />;
          } else if(localStorage.getItem("SelectedMotiv") == 2){
            motiv2Image = <input type={"radio"} id={"Motiv2"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-50px'}} checked={true} onClick={() =>{this.handleChange();}} />;
          } else if(localStorage.getItem("SelectedMotiv") == 3){
            motiv3Image = <input type={"radio"} id={"Motiv3"} name={"motiv1"} value={"30"} style={{marginRight: '20px', position: 'relative', top: '-50px'}} checked={true} onClick={() =>{this.handleChange();}} />;
          }

          localStorage.removeItem("SelectedMotiv");
        }

        return (<div className="TariffingContainer" >
          <div 
            className={"tariffingform"} 
            style={{ textAlign:'left' }}>
            <br />
            <br />
            <div style={{position: 'sticky', bottom: '0px', paddingTop: '10px', 
                         display: 'flex', justifyContent: 'space-around', alignItems: 'center'}}>
            </div>
            <br />
            <br />
            <table>
            <thead>
                <tr>
                  <th></th>
                  <th>
                    <div
                      id={"LoadingIcon"}
                      className={'hide'}></div>
                  </th>
                </tr>
                <tr>
                    <th >
                        <div id={"HintContractStart"} style={{textAlign:"center",fontWeight:"normal",fontSize:"14px"}}>
                          <div id={"HintContractStartText"}>{Vas.Resources.Labels["InfoText"]} 
                              <div  style={{fontSize:'12px',display:'inline'}}>{Vas.Resources.Labels["LocalRate"]}</div>
                              <div style={{display:'inline'}}>{Vas.Resources.Labels["InfoText2"]}</div>
                          </div>
                        </div>
                    </th>
                </tr>
                <tr>
                  <th>
                    <h2 id={"PriceInfoHeader"}>{Vas.Resources.Labels["PriceInformation"]}</h2>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                  {/*<TariffingPointsToProduct
                    ApplicationUrl={Vas.ApplicationUrl}
                    ApiKey={Vas.ApiKey}
                    ApiUrl={Vas.ApiUrl}
                    TimeOutTime={Vas.TimeOutTime}
                    Text={<div>
                        <br/>
                          {Vas.Resources.Labels["TextBärenTicketYoungTicket"]}
                          <br/><br/>
                          <b  style={{ fontSize: '14px', fontStyle: 'italic' }}>{Vas.Resources.Labels["TextBärenTicketYoungTicketZusatz1"]}</b>
                          {Vas.Resources.Labels["And2"]}
                          <b  style={{ fontSize: '14px', fontStyle: 'italic' }}>{Vas.Resources.Labels["TextBärenTicketYoungTicketZusatz2"]}</b>
                          </div>}
                          ref ={"Tariffing"}
                    ShowContractEnd={true}
                    />*/}

                    <div id={"TermsOfUsage"} className={"termsOfUsage"} >

                    <div id={"ChooseDeutschlandTicket"} style={{display: 'none'}}> {Vas.Resources.Labels["GermanTicketChipCardHint"]} <br/><br/>
                      <div id="Deutschlandticket (Motiv1)" style={{marginBottom: '10px'}}>
                        <div style={{marginLeft: '90px'}}>Motiv 1</div>
                        {motiv1Image}
                        <img src="../../images/tariff/Motiv1.PNG" name="Deutschland-Ticket (Motiv 1)" alt="Motiv1" style={{ width: '226.67px' }}/>
                      </div>
                      <div id="Deutschlandticket (Motiv2)" style={{marginBottom: '10px'}}>
                        <div style={{marginLeft: '90px'}}>Motiv 2</div>
                        {motiv2Image}
                        <img src="../../images/tariff/Motiv2.PNG" name="Deutschland-Ticket (Motiv 2)" alt="Motiv2" style={{ width: '226.67px' }}/>
                      </div>
                      <div id="Deutschlandticket (Motiv3)">
                        <div style={{marginLeft: '90px'}}>Motiv 3</div>
                        {motiv3Image}
                        <img src="../../images/tariff/Motiv3.PNG" name="Deutschland-Ticket (Motiv 3)" alt="Motiv3" style={{ width: '226.67px' }}/>
                      </div>
                    </div>

                    <table id="termsOfUsage"><tbody></tbody></table>
                    </div>

                    <TariffingProductsToPoints
                      ShowClientsBox={false}
                      ShowContractEnd={true}
                      ApplicationUrl={Vas.ApplicationUrl}
                      ApiKey={Vas.ApiKey}
                      ApiUrl={Vas.ApiUrl}
                      TimeOutTime={Vas.TimeOutTime}
                      ContractEndText={Vas.Resources.Labels["TermUntil"]}
                      ConfigDefaults={Vas.Config.Defaults}
                      ConfigContractEnd={Vas.Config.ContractEnd}
                      ErrorHandling={(error)=>{Vas.ErrorHandling(error)}}
                      ShowPriceLevel={true}
                      ShowTariffPointIdent={false}
                      DeleteRelationTo={false}
                      TariffPointSearchlegth={1}
                      FilteredProductIdents={"01-96-02;01-99-02;01-991-02;01-992-02;01-993-02"}
                    // Text={<div>
                    //     <br/>
                    //       {Vas.Resources.Labels["TextBärenTicketYoungTicket"]}
                    //       <br/><br/>
                    //       <b  style={{ fontSize: '14px', fontStyle: 'italic' }}>{Vas.Resources.Labels["TextBärenTicketYoungTicketZusatz1"]}</b>
                    //       {Vas.Resources.Labels["And2"]}
                    //       <b  style={{ fontSize: '14px', fontStyle: 'italic' }}>{Vas.Resources.Labels["TextBärenTicketYoungTicketZusatz2"]}</b>
                    //       </div>}
                    ref ={"Tariffing"}
                    SubstringsAllowed={true}
                    FindStrFromStreets={true} />
                  </td>
                </tr>
                {dataProtection}
                <tr>
                  <td>
                    <br /><div style={{ fontSize: '13px' }}>{Vas.Resources.Labels["RequiredField"]}</div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <br />
                    <div id={"TariffingOrderAs"} style={{ textAlign: 'center', marginTop: '20px' }}>
                      {Vas.Resources.Labels["OrderAs"]}
                    </div>
                  </td>
                </tr>
                <tr  >
                  <td>
                    <br />
                    <div >
                      <div className={"TariffingButtonLeft"} style={{ textAlign: 'center' }} >
                      <ExtendedButton 
                        ref={"Order"} 
                        Usable={true} 
                        Text={Vas.Resources.Labels["OrderRegistrated"]} 
                        OnClick={()=>{ this.Order();}}
                        Width={398}
                        Id={"btoOrder"} /></div>
                    <div className={"TariffingButtonRight"} style={{ textAlign: 'center' }}>
                      <ExtendedButton 
                        ref={"Order2"} 
                        Usable={true} 
                        Text={Vas.Resources.Labels["OrderNonRegistrated"]} 
                        OnClick={()=>{ this.Order2();}}
                        Width={398}
                        Id={"btoOrder2"} />
                    </div>
                    </div>
                        
                  </td> 
                </tr>
              </tbody>
            </table>
            
          </div>
        </div>);
    }
}
export default Tariffing;
